import { Component, TemplateFunction } from '@ribajs/core'
import { ShopifyProductService } from '../services/index.js'
import { SbCardProductComponent } from './sb-card-product.component.js'
import { SbPopupComponent } from './sb-popup.component.js'

import type { CardProductOption, VariantOverlayData } from '../types/index.js'

/**
 * The types for the scope
 */
interface Scope extends VariantOverlayData {
  // OPTIONS
  options: CardProductOption[]
  showSecondOptions: boolean
  showMoreOptions: boolean
  showSpinner: boolean
  /** true if the variant is available, used to disable the add to cart button */
  available: boolean
  /** Is true if the user has chosen an option */
  optionSelected: boolean

  // METHODS

  // TEMPLATES

  // Elements
  options1El?: HTMLDivElement
  options2El?: HTMLDivElement
}

/**
 * A product variant overlay, used in the variant overlay popup
 */
export class SbVariantOverlayComponent extends Component {
  public static tagName = 'sb-variant-overlay'

  lifecycleOptions = {
    ignore: true,
  }

  public cardProductEls: SbCardProductComponent[] = []
  public popupEl: SbPopupComponent | null = null

  public scope: Scope = {
    // OPTIONS
    handle: '',
    product: undefined,
    variant: undefined,
    featured_image: {},
    productBgColor: '',
    options: [],
    quantity: 1,
    isRecommendation: false,
    isFavorite: false,
    showSecondOptions: false,
    showMoreOptions: false,
    showSpinner: true,
    optionSelected: false,
    available: false,

    // METHODS

    // TEMPLATES
  }

  static get observedAttributes(): string[] {
    return [
      'handle',
      'product',
      'variant',
      'featured_image',
      'product-bg-color',
    ]
  }

  protected requiredAttributes(): string[] {
    return ['product']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbVariantOverlayComponent.observedAttributes)
  }

  protected disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }

  protected onProductAttrChanged() {
    const variantBelongsToProduct = !!this.scope.product?.variants.find(
      v => v.id === this.scope.variant?.id,
    )

    if (!variantBelongsToProduct) {
      this.scope.variant = undefined
    }
  }

  protected onVariantAttrChanged() {
    // nothing yet used
  }

  protected onBgColorAttrChanged() {
    if (this.popupEl) {
      ShopifyProductService.setImageBgColor(
        this.popupEl,
        this.scope.productBgColor,
      )
    }
    ShopifyProductService.setImageBgColor(this, this.scope.productBgColor)
  }

  protected parsedAttributeChangedCallback(
    attributeName: string,
    oldValue: any,
    newValue: any,
    namespace: string | null,
  ): void {
    super.parsedAttributeChangedCallback(
      attributeName,
      oldValue,
      newValue,
      namespace,
    )
    if (attributeName === 'product') {
      this.onProductAttrChanged()
    }
    if (attributeName === 'variant') {
      this.onVariantAttrChanged()
    }
    if (attributeName === 'productBgColor') {
      this.onBgColorAttrChanged()
    }
  }

  async beforeBind() {
    this.setPopupEl()
    this.addEventListeners()
  }

  async afterBind() {
    this.setPopupEl()
    this.addEventListeners()
    this.classList.add(`${SbVariantOverlayComponent.tagName}-ready`)
    await super.afterBind()
  }

  protected setPopupEl() {
    if (!this.popupEl) {
      this.popupEl = this.closest(SbPopupComponent.tagName)
      // Set color again if popupEl was not defined before
      this.onBgColorAttrChanged()
    }
  }

  protected addEventListeners() {
    this.removeEventListeners()
  }

  protected removeEventListeners() {
    // nothing yet
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
